/* eslint-disable @next/next/no-img-element */
import React from 'react'
import { dFlexCenter } from '@zuto/theme/src/mui/UtilityStyles'
import { styled } from '@mui/material'
import { tonalPalettes } from '@zuto/theme/src/mui/Colors'

const FloatingIcon = styled('div')(({ theme }) => ({
  ...dFlexCenter,
  borderRadius: '22px',
  border: '1px solid rgba(255, 255, 255, 0.60)',
  boxShadow: '4px 4px 10px 0px rgba(0, 0, 0, 0.10)',
  backdropFilter: 'blur(5px)',
  minWidth: '70px',
  minHeight: '70px',
  maxWidth: '70px',
  maxHeight: '70px',
  marginBottom: '16px',
  backgroundColor: tonalPalettes.primary[100],
  [theme.breakpoints.up('sm')]: {
    minWidth: '85px',
    minHeight: '70px',
    maxWidth: '85px',
    maxHeight: '70px'
  }
}))

const FloatingCardIcon = ({ icon, iconAlt }: { icon: string; iconAlt: string }) => {
  return (
    <FloatingIcon className="floating-card-icon">
      {/* NextJS Image component doesn't support SVGs as images. */}
      <img src={icon} alt={iconAlt} width={40} height={40} />
    </FloatingIcon>
  )
}

export default FloatingCardIcon
